export function getAllCoefIoLm(axiosPrivate) {
  return axiosPrivate.get('/coef-io-lm')
}

export function getCoefIoLmById(axiosPrivate, id) {
  return axiosPrivate.get(`/coef-io-lm/${id}`)
}

export function createCoefIoLm(axiosPrivate, data) {
  return axiosPrivate.post('/coef-io-lm', data)
}

export function updateCoefIoLmById(axiosPrivate, id, data) {
  return axiosPrivate.put(`/coef-io-lm/${id}`, data)
}

export function deleteCoefIoLm(axiosPrivate, id) {
  return axiosPrivate.delete(`/coef-io-lm/${id}`)
}
